import { useCommunityContext } from 'providers';
import { useMemo } from 'react';

import { useListCommunityProductMembershipsQuery } from 'shared/graphql';

/**
 * A custom hook to fetch memberships belonging to the currently selected community.
 * @see https://github.com/jebelapp/jebel/issues/1884
 */
export function useCommunityProductMemberships() {
  const { selectedCommunity } = useCommunityContext();

  const { data: response, loading } = useListCommunityProductMembershipsQuery({
    skip: !selectedCommunity?.id,
    variables: { community: selectedCommunity?.id as string },
  });

  const data = useMemo(() => {
    return response?.memberships ?? [];
  }, [response]);

  return {
    data,
    loading,
  };
}
